import * as actionTypes from "./actionTypes";
import * as types from "./types";

const initState: types.IAuthState = {
    profile: null,
    roles: [],   
    accessToken: "",
    tokenClaims: null,    
};

export const UserAuthReducer = (state = initState, action: types.UserAuthActions) => {
    switch (action.type) {
        case actionTypes.SET_PROFILE_DATA:
            return {
                ...state,
                profile: action.data,
            };       
        case actionTypes.SET_ROLE_CLAIMS:
            return {
                ...state,
                roles: action.data,
            };
        case actionTypes.SET_ACCESS_TOKEN:
            return {
                ...state,
                accessToken: action.data,
            };
        case actionTypes.SET_TOKEN_CLAIMS:
            return {
                ...state,
                tokenClaims: action.data,
            };
        default:
            return {
                ...state,
            };
    }
};